import http from "@http"

//列表  不分页
export function getStationAll(data) {
    return http({
        url: '/lskj-data/api/data/station/all',
        method: "post",
        data
    })
}
//列表  分页
export function getStationList(data) {
    return http({
        url: '/lskj-data/api/data/station/list',
        method: "post",
        data
    })
}

//查询单条
export function stationById(data) {
    return http({
        url: `/lskj-data/api/data/station/byId?id=${data.id}`,
        method: "get",
    })
}

//添加
export function stationAdd(data) {
    return http({
        url: '/lskj-data/api/data/station/add',
        method: "post",
        data
    })
}

//修改
export function updeteStation(data) {
    return http({
        url: `/lskj-data/api/data/station`,
        method: "put",
        data
    })
}
//删除
export function deleteStation(data) {
    return http({
        url: `/lskj-data/api/data/station?ids=${data.ids}`,
        method: "delete",
        data
    })
}

//区站树
export function stationTree(data) {
    return http({
        url: '/lskj-data/api/data/station/tree',
        method: "post",
        data
    })
}